<script>
  export let duration, time;

  $: progress = time / duration  * 100;
  let buffer = 0;
</script>

<div id="loading_bar_container">
  <div id="loading_bar">
    <div id="buffer" style="width:{buffer}%"></div>
    <div id="progress" style="width:{progress}%"></div>
  </div>
</div>

<style>
  #loading_bar_container {
  background-color: #bbb;
  position: relative;
  top: 7px;
  left: 2px;
  width: calc(100% - 4px);
  height:5px;
  overflow:hidden;
}

#loading_bar {
  position:relative;
  height:8px;
}

#buffer, #progress {
  height:8px;
  position:absolute;
  width:0%;
  top:0;
}

#buffer {
  background-color:#AFE5DF;
}

#progress {
  background-color:#00A793;
}
</style>
